import { connect } from 'react-redux'
import { State } from '../../../store'
import PrivateRoutePresentation from '../PrivateRoutePresentation'

export default connect((state: State) => ({
  isAuthorized: !!state.auth.register.signicat.callback_response.state,
  pathname: '/register/identity-verification',
}))(PrivateRoutePresentation)
